import Gdk from "gi://Gdk";

export const getKeyCodeFromName = (keyName: string) => {
  switch (keyName.toUpperCase()) {
    case "SHIFT":
    case "SHIFT_L":
    case "SHIFT_LEFT":
    case "SHIFTL":
    case "SHIFTLEFT":
      return Gdk.KEY_Shift_L;
    case "SHIFT_R":
    case "SHIFT_RIGHT":
    case "SHIFTR":
    case "SHIFTRIGHT":
      return Gdk.KEY_Shift_R;
    case "ALT":
    case "ALT_L":
    case "ALT_LEFT":
    case "ALTL":
    case "ALTLEFT":
      return Gdk.KEY_Alt_L;
    case "ALT_R":
    case "ALT_RIGHT":
    case "ALTR":
    case "ALTRIGHT":
      return Gdk.KEY_Alt_R;
    case "CAPS_LOCK":
    case "CAPSLOCK":
      return Gdk.KEY_Caps_Lock;
    case "SUPER":
    case "SUPER_L":
    case "SUPER_LEFT":
    case "SUPERL":
    case "SUPERLEFT":
      return Gdk.KEY_Super_L;
    case "SUPER_R":
    case "SUPER_RIGHT":
    case "SUPERR":
    case "SUPERRIGHT":
      return Gdk.KEY_Super_R;
    case "CONTROL":
    case "CONTROL_L":
    case "CONTROL_LEFT":
    case "CONTROLL":
    case "CONTROLLEFT":
      return Gdk.KEY_Control_L;
    case "CONTROL_R":
    case "CONTROL_RIGHT":
    case "CONTROLR":
    case "CONTROLRIGHT":
      return Gdk.KEY_Control_R;
    case "BACK_SPACE":
    case "BACKSPACE":
      return Gdk.KEY_BackSpace;
    case "SCROLL_LOCK":
    case "SCROLLLOCK":
      return Gdk.KEY_Scroll_Lock;
    case "ENTER":
      return Gdk.KEY_Return;
    case "ESCAPE":
      return Gdk.KEY_Escape;
    case "TAB":
      return Gdk.KEY_Tab;
    case "SPACE":
      return Gdk.KEY_space;
    case "PAGE_UP":
    case "PAGEUP":
      return Gdk.KEY_Page_Up;
    case "PAGE_DOWN":
    case "PAGEDOWN":
      return Gdk.KEY_Page_Down;
    case "END":
      return Gdk.KEY_End;
    case "HOME":
      return Gdk.KEY_Home;
    case "INSERT":
      return Gdk.KEY_Insert;
    case "DELETE":
      return Gdk.KEY_Delete;
    case "NUM_LOCK":
    case "NUMLOCK":
      return Gdk.KEY_Num_Lock;
    case "PRINT":
    case "PRINT_SCREEN":
    case "PRINTSCREEN":
      return Gdk.KEY_Print;
    case "PAUSE":
      return Gdk.KEY_Pause;
    case "LEFT":
    case "ARROW_LEFT":
    case "ARROW_L":
    case "ARROWLEFT":
    case "ARROWL":
      return Gdk.KEY_Left;
    case "UP":
    case "ARROW_UP":
    case "ARROW_U":
    case "ARROWUP":
    case "ARROWU":
      return Gdk.KEY_Up;
    case "RIGHT":
    case "ARROW_RIGHT":
    case "ARROW_R":
    case "ARROWRIGHT":
    case "ARROWR":
      return Gdk.KEY_Right;
    case "DOWN":
    case "ARROW_DOWN":
    case "ARROW_D":
    case "ARROWDOWN":
    case "ARROWD":
      return Gdk.KEY_Down;
    case "F1":
      return Gdk.KEY_F1;
    case "F2":
      return Gdk.KEY_F2;
    case "F3":
      return Gdk.KEY_F3;
    case "F4":
      return Gdk.KEY_F4;
    case "F5":
      return Gdk.KEY_F5;
    case "F6":
      return Gdk.KEY_F6;
    case "F7":
      return Gdk.KEY_F7;
    case "F8":
      return Gdk.KEY_F8;
    case "F9":
      return Gdk.KEY_F9;
    case "F10":
      return Gdk.KEY_F10;
    case "F11":
      return Gdk.KEY_F11;
    case "F12":
      return Gdk.KEY_F12;
    case "?":
    case "QUESTION":
    case "QUESTION_MARK":
    case "QUESTIONMARK":
      return Gdk.KEY_question;
    case "!":
    case "EXCLAMATION":
    case "EXCLAMATION_MARK":
    case "EXCLAMATIONMARK":
      return Gdk.KEY_exclam;
    case "@":
    case "AT":
    case "AT_SIGN":
    case "ATSIGN":
      return Gdk.KEY_at;
    case "#":
    case "HASH":
    case "HASH_SIGN":
    case "HASHSIGN":
    case "NUMBER_SIGN":
    case "NUMBERSIGN":
      return Gdk.KEY_numbersign;
    case "$":
    case "DOLLAR":
    case "DOLLAR_SIGN":
    case "DOLLARSIGN":
      return Gdk.KEY_dollar;
    case "%":
    case "PERCENT":
    case "PERCENT_SIGN":
    case "PERCENTSIGN":
      return Gdk.KEY_percent;
    case "^":
    case "CARET":
    case "CARET_SIGN":
    case "CARETSIGN":
      return Gdk.KEY_asciicircum;
    case "&":
    case "AMPERSAND":
    case "AMPERSAND_SIGN":
    case "AMPERSANDSIGN":
      return Gdk.KEY_ampersand;
    case "*":
    case "ASTERISK":
    case "ASTERISK_SIGN":
    case "ASTERISKSIGN":
      return Gdk.KEY_asterisk;
    case "(":
    case "PARENTHESIS":
    case "PARENTHESIS_LEFT":
    case "PARENTHESIS_L":
    case "PARENTHESISLEFT":
    case "PARENTHESISL":
      return Gdk.KEY_parenleft;
    case ")":
    case "PARENTHESIS_RIGHT":
    case "PARENTHESIS_R":
    case "PARENTHESISRIGHT":
    case "PARENTHESISR":
      return Gdk.KEY_parenright;
    case "_":
    case "UNDERSCORE":
    case "UNDERSCORE_SIGN":
    case "UNDERSCORESIGN":
    case "FLOOR":
    case "FLOOR_SIGN":
    case "FLOORSIGN":
      return Gdk.KEY_underscore;
    case "+":
    case "PLUS":
    case "PLUS_SIGN":
    case "PLUSSIGN":
      return Gdk.KEY_plus;
    case "{":
    case "BRACE":
    case "BRACE_LEFT":
    case "BRACE_L":
    case "BRACELEFT":
    case "BRACEL":
      return Gdk.KEY_braceleft;
    case "}":
    case "BRACE_RIGHT":
    case "BRACE_R":
    case "BRACERIGHT":
    case "BRACER":
      return Gdk.KEY_braceright;
    case "|":
    case "PIPE":
    case "PIPE_SIGN":
    case "PIPESIGN":
      return Gdk.KEY_bar;
    case ":":
    case "COLON":
    case "COLON_SIGN":
    case "COLONSIGN":
      return Gdk.KEY_colon;
    case "\"":
    case "DOUBLE_QUOTE":
    case "DOUBLEQUOTE":
      return Gdk.KEY_quotedbl;
    case "<":
    case "LESS":
    case "LESS_SIGN":
    case "LESSSIGN":
      return Gdk.KEY_less;
    case ">":
    case "GREATER":
    case "GREATER_SIGN":
    case "GREATERSIGN":
      return Gdk.KEY_greater;
    case "~":
    case "TILDE":
    case "TILDE_SIGN":
    case "TILDESIGN":
      return Gdk.KEY_asciitilde;
    case "`":
    case "GRAVE":
    case "GRAVE_SIGN":
    case "GRAVESIGN":
      return Gdk.KEY_grave;
    case "-":
    case "MINUS":
    case "MINUS_SIGN":
    case "MINUSSIGN":
    case "HYPHEN":
    case "HYPHEN_SIGN":
    case "HYPHENSIGN":
    case "DASH":
    case "DASH_SIGN":
    case "DASHSIGN":
      return Gdk.KEY_minus;
    case "=":
    case "EQUAL":
    case "EQUAL_SIGN":
    case "EQUALSIGN":
      return Gdk.KEY_equal;
    case "[":
    case "BRACKET":
    case "BRACKET_LEFT":
    case "BRACKET_L":
    case "BRACKETLEFT":
    case "BRACKETL":
      return Gdk.KEY_bracketleft;
    case "]":
    case "BRACKET_RIGHT":
    case "BRACKET_R":
    case "BRACKETRIGHT":
    case "BRACKETR":
      return Gdk.KEY_bracketright;
    case "\\":
    case "BACKSLASH":
    case "BACKSLASH_SIGN":
    case "BACKSLASHSIGN":
      return Gdk.KEY_backslash;
    case ";":
    case "SEMICOLON":
    case "SEMICOLON_SIGN":
    case "SEMICOLONSIGN":
      return Gdk.KEY_semicolon;
    case "'":
    case "APOSTROPHE":
    case "APOSTROPHE_SIGN":
    case "APOSTROPHESIGN":
      return Gdk.KEY_apostrophe;
    case ".":
    case "PERIOD":
    case "PERIOD_SIGN":
    case "PERIODSIGN":
    case "DOT":
    case "DOT_SIGN":
    case "DOTSIGN":
      return Gdk.KEY_period;
    case "/":
    case "SLASH":
    case "SLASH_SIGN":
    case "SLASHSIGN":
      return Gdk.KEY_slash;
  }

  return Gdk.keyval_from_name(keyName);
};
